import React from "react";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";
import { tokens } from "../../theme";
import { BrandMark, IconLogout, IconPlus } from "../ui/icons";
import { getPageTitle, ROUTES } from "./navConfig";

moment.locale("es");

/**
 * Barra superior. En mobile se reduce a marca + título; el botón de nueva orden
 * vive ahí abajo, en la barra inferior, donde llega el pulgar.
 */
const TopBar = ({ isMobile, onLogout }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const title = getPageTitle(pathname);
  const today = moment().format("dddd D [de] MMMM");
  const subtitle = today.charAt(0).toUpperCase() + today.slice(1);

  return (
    <Box
      component="header"
      sx={{
        height: isMobile ? 56 : tokens.topbarHeight,
        flexShrink: 0,
        backgroundColor: tokens.surface,
        borderBottom: `1px solid ${tokens.border}`,
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "10px" : "16px",
        padding: isMobile ? "0 16px" : "0 28px",
      }}
    >
      {isMobile && (
        <Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: "8px",
            backgroundColor: tokens.borderSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <BrandMark size={17} />
        </Box>
      )}

      <Box sx={{ display: "flex", flexDirection: "column", gap: "1px", minWidth: 0, flexGrow: 1 }}>
        <Typography
          sx={{
            fontSize: isMobile ? "15px" : "16px",
            fontWeight: 600,
            letterSpacing: "-0.01em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        <Typography sx={{ fontSize: isMobile ? "11.5px" : "12px", color: tokens.ink3 }}>
          {subtitle}
        </Typography>
      </Box>

      {!isMobile && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<IconPlus size={16} />}
          onClick={() => {
            localStorage.removeItem("signatureData");
            navigate(ROUTES.newOrder);
          }}
          sx={{ height: 36 }}
        >
          Nueva orden
        </Button>
      )}

      {isMobile && (
        <Tooltip title="Cerrar sesión" arrow>
          <Box
            onClick={onLogout}
            aria-label="Cerrar sesión"
            sx={{
              width: 44,
              height: 44,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: tokens.ink2,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <IconLogout size={20} />
          </Box>
        </Tooltip>
      )}

    </Box>
  );
};

export default TopBar;
